import script from "./PicturesActionsMixins.vue?vue&type=script&lang=js"
export * from "./PicturesActionsMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__